import {
  SIDEBAR_CAMPAIGNS,
  SIDEBAR_PAYMENTS,
  SIDEBAR_REVIEWS,
  SIDEBAR_WEBCHAT,
  SIDEBAR_DEFAULT,
} from 'components/Trials/constants';
import Reviews from './views/Reviews';
import Payments from './views/Payments';
import Webchat from './views/Webchat';
import Campaigns from './views/Campaigns';
import Sidebar from './views/DefaultSidebar';

export const getPopAnimationProps = (delay, duration) => {
  return {
    initial: {
      opacity: 0,
      scale: 0,
    },
    animate: {
      opacity: [0, 1, 1],
      scale: [0, 1, 1],
    },
    transition: {
      ease: 'backInOut',
      type: 'spring',
      stiffness: 150,
      duration,
      delay,
    },
  };
};

export const getFadeUpAnimationProps = (delay, duration) => {
  return {
    initial: {
      opacity: 0,
      y: 20,
    },
    animate: {
      opacity: 1,
      y: 0,
    },
    transition: {
      duration,
      delay,
    },
  };
};

export const getHeading = (sidebarVariant) => {
  switch (sidebarVariant) {
    case SIDEBAR_REVIEWS:
      return 'The easiest way to 2X your monthly reviews in 60 days.';
    case SIDEBAR_PAYMENTS:
      return 'Get paid 5x faster with text-to-pay and mobile card readers.';
    case SIDEBAR_WEBCHAT:
      return 'Get ready for 11x more leads from your website traffic.';
    case SIDEBAR_CAMPAIGNS:
      return 'Offers sent by text get opened 98% of the time.';
    case SIDEBAR_DEFAULT:
    default:
      return 'Join 100,000+ businesses using Podium to grow';
  }
};

export const getComponent = (sidebarVariant) => {
  switch (sidebarVariant) {
    case SIDEBAR_REVIEWS:
      return <Reviews />;
    case SIDEBAR_PAYMENTS:
      return <Payments />;
    case SIDEBAR_WEBCHAT:
      return <Webchat />;
    case SIDEBAR_CAMPAIGNS:
      return <Campaigns />;
    case SIDEBAR_DEFAULT:
    default:
      return <Sidebar />;
  }
};
